import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ascendLogo from '../../../assets/ACS-Images/Ascend-Logo.png';

const FTPLocation = () => {
  const navigate = useNavigate();
  const [ftpData, setFtpData] = useState({
    address: "",
    username: "",
    password: "",
  });

  const handleChange = (field, value) => {
    setFtpData((prev) => ({ ...prev, [field]: value }));
  };

  const handleTestConnection = () => {
    console.log("Testing FTP connection with:", ftpData);
    // Optional: Add logic to test connection
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/onboarding/team-onboard");
  };

  return (
    <div className="w-full min-h-screen bg-white flex items-center justify-center">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-5xl px-fluid-3 md:px-fluid-4 py-fluid-4 space-y-fluid-4"
      >
        {/* Logo */}
        <div className="flex flex-col items-center">
          <img
            src={ascendLogo}
            alt="Ascend Logo"
            className="w-32 md:w-40 mb-fluid-2 hover:scale-105 transition-transform duration-300"
          />

          {/* Stepper */}
          <div className="flex items-center justify-center gap-fluid-2 mt-fluid-1 mb-fluid-2">
            {["Invite your team", "FTP location", "Success"].map((label, idx) => {
              const isActive = idx === 1;
              const isCompleted = idx < 1;

              return (
                <React.Fragment key={idx}>
                  {idx > 0 && <div className="w-8 border-t-2 border-gray-300"></div>}
                  <div className="flex flex-col items-center">
                    <div className={`w-8 h-8 rounded-full font-semibold flex items-center justify-center
                      ${isCompleted ? "bg-[#223688] text-white border-2 border-[#223688]" : ""}
                      ${isActive ? "border-2 border-[#223688] bg-[#e8edff] text-[#223688]" : ""}
                      ${!isActive && !isCompleted ? "border border-gray-300 bg-white text-gray-400" : ""}`}>
                      {idx + 1}
                    </div>
                    <span className={`mt-fluid-0.5 text-sm font-semibold text-center
                      ${isActive ? "text-black" : ""}
                      ${!isActive && !isCompleted ? "text-gray-400" : ""}
                      ${isCompleted ? "text-[#223688]" : ""}`}>
                      {label}
                    </span>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>

        {/* Title */}
        <h1 className="text-center text-fluid-xl font-bold">Add your FTP location</h1>

        {/* Inputs */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-fluid-2 mt-fluid-2">
          <input
            type="text"
            placeholder="FTP address"
            value={ftpData.address}
            onChange={(e) => handleChange("address", e.target.value)}
            className="w-full border border-gray-300 rounded-full px-fluid-input-x py-fluid-input-y"
          />
          <input
            type="text"
            placeholder="FTP username"
            value={ftpData.username}
            onChange={(e) => handleChange("username", e.target.value)}
            className="w-full border border-gray-300 rounded-full px-fluid-input-x py-fluid-input-y"
          />
          <input
            type="password"
            placeholder="FTP password"
            value={ftpData.password}
            onChange={(e) => handleChange("password", e.target.value)}
            className="w-full border border-gray-300 rounded-full px-fluid-input-x py-fluid-input-y"
          />
          <button
            type="button"
            onClick={handleTestConnection}
            className="bg-[#223688] text-white px-fluid-button-x py-fluid-button-y rounded-full hover:bg-[#1c2c6d] transition w-full"
          >
            Test
          </button>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-center gap-6 mt-fluid-4">
          <button
            type="button"
            onClick={() => navigate("/onboarding/invite-team")}
            className="w-40 px-fluid-button-x py-fluid-button-y border-2 border-[#223688] text-[#223688] rounded-full hover:bg-[#eef0ff] transition"
          >
            Back
          </button>
          <button
            type="submit"
            className="w-40 px-fluid-button-x py-fluid-button-y bg-[#223688] text-white rounded-full hover:bg-[#1c2c6d] transition"
          >
            Continue
          </button>
        </div>
      </form>
    </div>
  );
};

export default FTPLocation;
